module.exports = __webpack_public_path__ + "img/contacts-blue.7226d02b.svg";